"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardItem = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
// done like this instead of a template string so that the code is greppable for the individual classes
var screenClasses = {
    xs: "layout-xs",
    sm: "layout-sm",
    md: "layout-md",
    lg: "layout-lg",
    xl: "layout-xl",
};
exports.DashboardItem = function (_a) {
    var className = _a.className, screen = _a.screen, props = tslib_1.__rest(_a, ["className", "screen"]);
    return react_1.default.createElement("div", tslib_1.__assign({}, props, { className: classnames_1.default(className, "dash-item", "s-dash-item", screenClasses[screen]) }));
};
//# sourceMappingURL=DashboardItem.js.map